import { Foundation } from 'foundation-sites/js/foundation.core';

export default function initIntersectionObserver() {
  if (window.IntersectionObserver !== undefined) {
    const intersectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          intersectionObserver.unobserve(entry.target);
          let target = $(entry.target);
          if (target.attr('data-lazyload-target')) {
            target = $(target.attr('data-lazyload-target'));
          }
          target.addClass('loading');
          $.ajax($(entry.target).attr('data-lazyload')).then((content) => {
            target.removeClass('loading').html(content).foundation();
            const type = $(entry.target).attr('data-lazyload-type');
            const key = $(entry.target).attr('data-lazyload-key');
            if (type && key) {
              sessionStorage.setItem(`lazyload-${type}-key`, key);
              sessionStorage.setItem(`lazyload-${type}-data`, content);
            }
          });
        }
      });
    });

    $('[data-lazyload]').each(function () {
      let target = $(this);
      const type = target.attr('data-lazyload-type');
      const key = target.attr('data-lazyload-key');
      if (type && key && sessionStorage.getItem(`lazyload-${type}-key`) === key) {
        if (target.attr('data-lazyload-target')) {
          target = $(target.attr('data-lazyload-target'));
        }
        target.html(sessionStorage.getItem(`lazyload-${type}-data`));
      } else {
        intersectionObserver.observe(this);
      }
    });
  }
}

initIntersectionObserver();

$(window).on('load', () => {
  $('img').removeAttr('loading');
  $('.cms-background--lazy').removeClass('cms-background--lazy');
});

$(document).on('click', '[data-async-hamburger]', function() {
  const a = $(this).addClass('loading');
  const ul = a.parent().find('ul');
  const drilldown = ul.closest('[data-drilldown]');
  $.ajax({
    url: a.attr('data-async-hamburger'),
  }).then((result) => {
    ul.append(result);
    Foundation.reInit(drilldown);
    a.removeClass('loading').click();
  });
  a.removeAttr('data-async-hamburger');
});
